import React from 'react'
import styled, { css } from 'styled-components'

import Table from 'components/Table'

import GA4 from 'helpers/ga4'

import Resource from 'types/Resource'

import { screenSize } from 'styles/shared'

import { color } from 'styles/colors'

import Tooltip from 'components/Tooltip'

type Props = {
  video: Resource
  canShowCreationDate?: boolean
}

const WistiaVideoRow = ({ video, canShowCreationDate = false }: Props) => {
  const onClickVideoLink = (videoName: string) => {
    GA4.sendEvent({
      category: 'Help Videos',
      action: 'Click video link',
      label: videoName
    })
  }

  if (video == null) {
    return <></>
  }

  return (
    <S.TableRow key={video.name}>
      <Tooltip title={'Click to view'} placement="top">
        <S.NameThumbnailCell>
          <S.ThumbnailLink
              href={video.url}
              onClick={() => {
                onClickVideoLink(video.name)
              }}
              target="_blank"
              rel="noreferrer"
          >
            <S.ThumbnailImage
              src={'/img/play_thumbnail.svg'}
              alt={`${video.name}-thumbnail`}
            />
          </S.ThumbnailLink>
          <S.NameCell>
            <S.AnchorLink
              href={video.url}
              onClick={() => {
                onClickVideoLink(video.name)
              }}
              target="_blank"
              rel="noreferrer"
            >
              {video.name}
            </S.AnchorLink>
          </S.NameCell>
        </S.NameThumbnailCell>
      </Tooltip>
      <S.DescriptionCell>
        {video.description}
        <br />
        <i>{video.duration} minutes</i>
      </S.DescriptionCell>
      <S.DateCell>{video.wistiaUpdatedAt}</S.DateCell>
      {canShowCreationDate && <S.DateCell>{video.wistiaCreatedAt}</S.DateCell>}
    </S.TableRow>
  )
}

export default WistiaVideoRow

const cellStyle = css`
  padding: 5px;

  @media ${screenSize.medium} {
    font-size: 12px;
  }
`

const S = {
  DateCell: styled(Table.Cell)`
    ${cellStyle}
    flex-basis: 25%;
    padding-left: 15px;
  `,
  DescriptionCell: styled(Table.Cell)`
    ${cellStyle}
    flex: 2;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-basis: 50%;
    padding-left: 15px;
  `,
  NameThumbnailCell: styled(Table.Cell)`
    align-items: center;
    flex-basis: 25%;
  `,
  NameCell: styled(Table.Cell)`
    ${cellStyle}
    align-items: flex-start;
  `,
  TableRow: styled(Table.Row)`
    align-items: center;
    border-bottom: 1px solid ${color('wistiaVideoTableRowBorder')};
    margin: 10px;
    @media ${screenSize.small} {
      align-items: flex-start;
    }
  `,
  ThumbnailImage: styled.img`
    ${cellStyle}
    max-height: 80px;

    @media ${screenSize.medium} {
      padding: 0 0 0 5px;
      max-height: 30px;
    }
  `,
  ThumbnailLink: styled.a`
    display: inline-flex;
  `,
  AnchorLink: styled.a`
    color: ${color('warrantyText')};
    font-weight: 500;
    text-decoration: none;
    &:hover {
      color: ${color('warrantyText')};
    }
   `
}
